export { default } from "./LanguageSwitcher";